// src/redux/middleware/supplierFormPersistence.js

// Middleware to automatically persist supplier form data to localStorage
export const supplierFormPersistenceMiddleware = store => next => action => {
  // Call the next middleware
  const result = next(action);
  
  // Check if this is a supplier form action
  const supplierFormActions = [
    'SET_SUPPLIER_FORM_DATA',
    'UPDATE_SUPPLIER_FORM_DATA',
    'SET_SUPPLIER_EXTRACTED_DATA',
    'SET_SUPPLIER_RESOLVED_FIELDS',
    'SET_SUPPLIER_LOADING',
    'SET_SUPPLIER_LOADING_LABEL',
    'SET_SUPPLIER_RESULT',
    'SET_SUPPLIER_CURRENT_SECTION',
    'SET_SUPPLIER_SHOW_OUTPUT'
  ];
  
  if (supplierFormActions.includes(action.type)) {
    // Get the current supplier form state
    const supplierFormState = store.getState().supplierForm;
    
    // Save to localStorage
    try {
      localStorage.setItem('supplierFormState', JSON.stringify(supplierFormState));
    } catch (error) {
      console.warn('Failed to save supplier form state to localStorage:', error);
    }
  }
  
  // Clear localStorage when form is cleared
  if (action.type === 'CLEAR_SUPPLIER_FORM_DATA') {
    try {
      localStorage.removeItem('supplierFormState');
    } catch (error) {
      console.warn('Failed to clear supplier form state from localStorage:', error);
    }
  }
  
  return result;
};

// Function to load supplier form state from localStorage
export const loadSupplierFormState = () => {
  try {
    const savedState = localStorage.getItem('supplierFormState');
    return savedState ? JSON.parse(savedState) : null;
  } catch (error) {
    console.warn('Failed to load supplier form state from localStorage:', error);
    return null;
  }
}; 